import { Paper, Typography } from '@mui/material';

export default function ProfileSection({ icon, title, children, sx }) {
    return (
        <Paper
            variant="outlined"
            sx={{ p: 3, borderRadius: 3, mb: 3, ...sx }}
        >
            <Typography
                variant="h6"
                gutterBottom
                sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'secondary.main', fontWeight: 700 }}
            >
                {icon} {title}
            </Typography>
            {children}
        </Paper>
    );
}
